import React, { useEffect, useRef, useState, useContext } from "react";
import { BrowserRouter as Router, Switch, Route, Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faL } from "@fortawesome/free-solid-svg-icons";
import VisibilityToggle from "../../commonComponents/visibilitytoggle";
import ImageUploader from '../../commonComponents/Imageuploader';
import SwitchToggle from '../../commonComponents/Switchtoggle';
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import question from "../../assets/img/edit-profile/question.svg";
import Form from 'react-bootstrap/Form';
import { Collapse } from 'react-bootstrap';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { changeVisibilityStatus, editProfileDetails, getProfileDetails, removeUserCommunities } from "../../services/apiProfile";
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import Calender from "../../assets/icons/calendar.svg"
import moment from "moment";
import { ApiHelper } from "../../helpers/ApiHelper";
import { API } from "../../services/api";
import { getUserCommunities } from "../../services/apiPosts";
import { setHours } from "date-fns";
import Validation from "../../commonComponents/Validation";
import swal from 'sweetalert';
import LeaveCommunity from "../JoinCommunity/popups/LeaveCommunity";
import DeleteAccount from "./DeleteAccount";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
import EditEmail from "./Editemail";
import CircularProgress from "../ProfileQuestion/CircularProgress";
import { MultiSelect } from 'primereact/multiselect';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // or any other theme
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { UserContext } from "../../config/userContext";
import { months } from "../../utils/Month";
import CustomDatePicker from "./CustomDate";

const EditProfile = () => {
    const user = JSON.parse(localStorage.getItem('userData'));
    const navigate = useNavigate()
    const { updateUser } = useContext(UserContext);
    const dateRef = useRef(null);
    const [profileImageVisible, setProfileImageVisible] = useState(true);
    const [isPrivateProfile, setIsPrivateProfile] = useState(false);
    const [showBio, setShowBio] = useState(false);
    const [showCountry, setShowCountry] = useState(false);
    const [showDob, setShowDob] = useState(false);
    const [showGender, setShowGender] = useState(false);
    const [showLocation, setShowLocation] = useState(false);
    const [showZipcode, setShowZipcode] = useState(false);
    const [showprofileImage, setShowprofileImage] = useState(false);
    const [showCoverImage, setShowCoverImage] = useState(false);
    const [dateValid, setDateValid] = useState(false);
    const [dateValidMap, setDateValidMap] = useState({});
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [zip, setZip] = useState('');
    const [bio, setBio] = useState('');
    const [gender, setGender] = useState('');
    const [phNo, setPhNo] = useState('');
    const [ethnicity, setEthnicity] = useState('');
    const [military, setMilitary] = useState('');
    const [dob, setDob] = useState('');
    const [month, setMonth] = useState('');
    const [day, setDay] = useState('');
    const [year, setYear] = useState('');
    const [dobError, setDobError] = useState('');
    const [dateError, setDateError] = useState('');
    const [location, setLocation] = useState('');
    const [country, setCountry] = useState('');
    const [proImg, setProImg] = useState('');
    const [coverImg, setCoverImg] = useState('');
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [countryArr, setCountryArr] = useState([]);
    const [CommunityArr, setCommunityArr] = useState([]);
    const [profileImgArr, setProfileImgArr] = useState([]);
    const [coverImgArr, setCoverImgArr] = useState([]);
    const [questionArr, setQuestioArr] = useState([]);
    const [questionArrBasic, setQuestioArrBasic] = useState([]);
    const [basicPercentage, setBasicPercentage] = useState('');
    const [basicQuestionArr, setBasicQuestionArr] = useState([]);
    const [individualBasicQuestions, setIndividualBasicQuestions] = useState([]);
    const [caregiverQuestionArr, setCaregiverQuestionArr] = useState([]);
    const [communityQuestionArr, setCommunityQuestionArr] = useState([]);
    const [emailError, setEmailError] = useState(false);
    const [isEmailExist, setIsEmailExist] = useState(false);
    const [error, setError] = useState(false);
    const [openStates, setOpenStates] = useState({});
    const firstNameRef = useRef(null);
    const lastNameRef = useRef(null);
    const dobRef = useRef(null);
    const zipRef = useRef(null);
    const [isLeaveCommunity, setIsLeaveCommunity] = useState(false);
    const handleLeaveClose = () => setIsLeaveCommunity(false);
    const [isDeleteAccount, setIsDeleteAccount] = useState(false);
    const handleDeleteAccountClose = () => setIsDeleteAccount(false);
    const [selectedCommunity, setSelectedCommunity] = useState(null);
    const [isSucess, SetSucess] = useState(false);
    const [ResponseMessage, SetResponseMessage] = useState("");
    const [isEditEmail, setIsEditEmail] = useState(false);
    const handleEditEmailClose = () => setIsEditEmail(false);
    const monthRefs = React.useRef({});
    const dayRefs = React.useRef({});
    const yearRefs = React.useRef({});
    const AUSTRALIA_ID = "681dde46519da80203bdf734";
    const [, forceRender] = React.useState(0); 

    useEffect(() => {
        fetchProfileDetails();
        getAllCountry();
    }, [])
    const fetchProfileDetails = async () => {
        const formData = {
            userid: user._id
        }
        let profile = await getProfileDetails(formData);
        setFirstName(profile?.user?.firstName);
        setLastName(profile?.user?.lastName);
        setEmail(profile?.user?.email);
        setGender(profile?.user?.gender);
        
        setCountry(profile?.user?.country);
        setLocation(profile?.user?.location);
        setZip(profile?.user?.zipcode);
        setBio(profile?.user?.bio);
        setEthnicity(profile?.user?.ethnicity);
        setMilitary(profile?.user?.militaryPerson);
        setPhNo(profile?.user?.phoneNumber);
        setCommunityArr(profile?.questions);
        setCommunityQuestionArr(profile?.communityquestions)
        setIndividualBasicQuestions(profile?.individualBasicQuestions)
        setCaregiverQuestionArr(profile?.caregiverquestions)
        
        setBasicPercentage(profile?.user?.basicProfileQuestionsCompleted)
        setProImg(profile.user?.profileImage?.url);
        setCoverImg(profile.user?.coverImage?.url);
        setIsPrivateProfile(profile?.user?.profileSettings?.isPrivateProfile);
        setShowCoverImage(profile?.user?.profileSettings?.showCoverImage)
        setShowBio(profile?.user?.profileSettings?.showBio);
        setShowCountry(profile?.user?.profileSettings?.showCountry);
        setShowDob(profile?.user?.profileSettings?.showDob);
        setShowGender(profile?.user?.profileSettings?.showGender);
        setShowLocation(profile?.user?.profileSettings?.showLocation);
        setShowZipcode(profile?.user?.profileSettings?.showZipcode);
        setShowprofileImage(profile?.user?.profileSettings?.showprofileImage);
        setProfileImgArr(profile?.user?.profileImage);
        setCoverImgArr(profile?.user?.coverImage);
        if (profile?.user?.dob) {
        const m = moment(profile.user.dob).format('MM');
        const d = moment(profile.user.dob).format('DD');
        const y = moment(profile.user.dob).format('YYYY');
        setMonth(m);
        setDay(d);
        setYear(y);
        setDob(`${m}/${d}/${y}`);
    }
    }
    const getAllCountry = async () => {
        await ApiHelper.post(API.countriesList)
            .then((resData) => {
                setCountryArr(resData.data.data)
            })
            .catch((err) => {
                console.log(err, 'err');
            });
    }
    const handleEmailSuccess = (message, status, email) => {
        if (status === true) {
            setEmail(email)
        }

        SetSucess(true);
        SetResponseMessage(message);
    };

    
    useEffect(() => {
        // 1️⃣ Flatten all community-level questions
        const communityQuestions = CommunityArr.flatMap(community => {
            const isCaregiver = community?.membertype?.[0]?.memberTypeDisplayName === "caregiver";
            const mergedQuestions = [
                ...(community.communityquestions || []),
                ...(isCaregiver ? community.caregiverquestions || [] : [])
            ];

            return mergedQuestions.map(q => ({
                questionid: q._id,
                answer: (() => {
                    const ans = q.answer?.[0]?.answer;
                    if (!ans) return [];
                    if (Array.isArray(ans)) {
                        const cleaned = ans.filter(s => s !== "");
                        return cleaned.length ? cleaned : [];
                    }
                    return ans === "" ? [] : [ans];
                })(),
                weightage: (() => {
                    const num = Number(String(q.weightage ?? "").trim());
                    return Number.isFinite(num) ? num : 0;
                })()
            }));
        });

        // 2️⃣ Add individual basic questions, in the same shape
        const individualQuestions = (individualBasicQuestions || []).map(q => ({
            questionid: q._id,
            answer: (() => {
                const ans = q.answer?.[0]?.answer;
                if (!ans) return [];
                if (Array.isArray(ans)) {
                    const cleaned = ans.filter(s => s !== "");
                    return cleaned.length ? cleaned : [];
                }
                return ans === "" ? [] : [ans];
            })(),
            weightage: (() => {
                const num = Number(String(q.weightage ?? "").trim());
                return Number.isFinite(num) ? num : 0;
            })()
        }));

        // 3️⃣ Combine both arrays together
        const allQuestions = [...individualQuestions, ...communityQuestions];

        
        setQuestioArr(allQuestions);
    }, [CommunityArr, individualBasicQuestions]);



    

    const openCalendar = () => {
        dateRef.current?.showPicker?.(); // Safe optional chaining
    };
    const handleFocus = () => {
        setIsCalendarOpen(true);
    };
    const handleChange = (selectedDate) => {
        setDob(selectedDate);
        setTimeout(() => {
            setIsCalendarOpen(false);
        }, 100);
    };

useEffect(() => {
    setDobError("")
  if (month && day && year) {
    const formattedDob = `${month}/${day.padStart(2, '0')}/${year}`;
    
    // Check if this is a valid date
    const parsedDate = new Date(formattedDob);
    const isValid =
      parsedDate instanceof Date &&
      !isNaN(parsedDate) &&
      parsedDate.getMonth() + 1 === parseInt(month) &&
      parsedDate.getDate() === parseInt(day) &&
      parsedDate.getFullYear() === parseInt(year);

    if (isValid) {
      setDob(formattedDob);
      setDateError(""); // ✅ clear error
    } else {
      setDob(""); // invalid date
      setDateError("Please enter a valid date"); // ❌ invalid
    }
  } else {
    setDob("");
    setDateError(""); // no error until all fields filled
  }
}, [month, day, year]);

    useEffect(() => {
        const fetchLocation = async () => {
            if (zip) {
                const result = await getLocationFromZip(zip);
                setLocation(result);
            }
            else {
                setLocation(""); // Clear location when zip is empty
            }
        };

        fetchLocation();
    }, [zip])
    const getLocationFromZip = async (zipCode) => {

        const apiKey = process.env.REACT_APP_ZIP_API
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=${apiKey}`;

        try {
            const response = await ApiHelper.get(url);

            // 🔒 Prevent accessing undefined when results are empty
            if (!response.data.results || response.data.results.length === 0) {
                console.warn('No results found for zip code:', zipCode);
                return '';
            }

            const components = response.data.results[0].address_components || [];

            const getComponent = (type) =>
                components.find((comp) => comp.types.includes(type))?.long_name || '';

            const streetNumber = getComponent('street_number');
            const route = getComponent('route');
            const city = getComponent('locality');
            const state = getComponent('administrative_area_level_1');
            const postalCode = getComponent('postal_code');
            const country = getComponent('country');

            const formattedAddress = `${city}, ${state}, ${country}`;

            return formattedAddress;
        } catch (error) {
            console.error('Geocoding API error:', error);
            return '';
        }
    };
    const handleVisibilityToggle = async (field, currentVisibility, setVisibility) => {
        const newVisibility = !currentVisibility;
        setVisibility(newVisibility);
        const formData = {
            userid: user._id,
            key: `profileSettings.${field}`,
            value: newVisibility
        }
        let visibilityToggle = await changeVisibilityStatus(formData);

    };
    const toggleCommunityCollapse = (communityId) => {
        setOpenStates((prev) => ({
            ...prev,
            [communityId]: !prev[communityId],
        }));
    };

    const removeCommunities = async () => {

        let id = selectedCommunity?.community[0]?._id
        setCommunityArr(prev => prev.filter(community => community.community[0]?._id !== id));
    };
    const onUploadComplete = (responseData, type) => {

        if (type === "profile") {
            setProfileImgArr(responseData);
        } else if (type === "cover") {
            setCoverImgArr(responseData); // Force re-render
        }
    };
    const validateDob = (selectedDate) => {
       if (!selectedDate) return false;
    

    const dateToValidate = moment.isMoment(selectedDate)
        ? selectedDate.toDate()
        : new Date(selectedDate);

    if (isNaN(dateToValidate.getTime())) return false;

    const today = new Date();

    // ✅ Dynamic age rule
    const minAge = country === AUSTRALIA_ID ? 16 : 13;
    
    

    const minDate = new Date(
        today.getFullYear() - minAge,
        today.getMonth(),
        today.getDate()
    );

    return dateToValidate <= minDate;
};
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toString(); // This will give you the format you want
    };
    // ⚙️ Generic handler for all question types
    const handleIndividualQuestionChange = (questionId, newValue) => {
        setIndividualBasicQuestions(prev => {
            const updated = [...prev];
            const idx = updated.findIndex(q => q._id === questionId);
            if (idx !== -1) {
                if (updated[idx].answer?.[0]) {
                    updated[idx].answer[0].answer = Array.isArray(newValue) ? newValue : [newValue];
                } else {
                    updated[idx].answer = [{ answer: Array.isArray(newValue) ? newValue : [newValue] }];
                }
            }
            return updated;
        });
    };

    const updateProfileDetails = async () => {
        if (dateError) {
            SetResponseMessage("Please correct invalid date entries before saving.");
            SetSucess(true);
            return; // 🔥 immediately stop submission
        }
        const hasInvalidQuestionDate = questionArr.some(
        (q) =>
            q.answer?.[0] === 'INVALID_DATE'
        
    );
    if (hasInvalidQuestionDate) {
        SetResponseMessage("Please correct invalid date entries before saving.");
        SetSucess(true); // show popup gently
        return;
    }
        if (firstName !== "" && lastName !== "" && email !== "" && dob !== "" && 
            (
                country !== "681dde46519da80203bdf80f" ||
                (country === "681dde46519da80203bdf80f" && zip !== "")
            )
        ) {

            setDobError("");
            if (validateDob(dob)) {
                setError(false);
                const formData = {
                    userid: user._id,
                    firstname: firstName,
                    lastname: lastName,
                    email: email,
                    gender: gender,
                    phonenumber: phNo,
                    militaryperson: military,
                    ethnicity: ethnicity,
                    dob: moment(dob).format('YYYY-MM-DD'),
                    country: country,
                    location: country === "681dde46519da80203bdf80f" ? location : "",
                    zipcode: country === "681dde46519da80203bdf80f" ? zip : "",
                    bio: bio,
                    profileimage: profileImgArr,
                    coverimage: coverImgArr,
                    questions: questionArr
                }
                
                let profile = await editProfileDetails(formData);
                if (profile.data) {
                    updateUser(profile.data);
                    localStorage.setItem('userData', JSON.stringify(profile.data));
                }
                fetchProfileDetails()
                if (profile.status) {
                    SetSucess(true);
                    SetResponseMessage(profile.message);
                }
            } else {
                const message =
                    country === '681dde46519da80203bdf734'
                        ? "To register from Australia, you need to be at least 16 years old."
                        : "You must be at least 13 years old.";

                setDobError(message);
                SetSucess(true);
                SetResponseMessage(message);
            }

        }
        else {
            setError(true);
            if (firstName === "") {
                firstNameRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                firstNameRef.current?.focus();
            } else if (lastName === "") {
                lastNameRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                lastNameRef.current?.focus();
            } else if (dob === "") {
                dobRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            else if (zip === "") {
                zipRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }
    const panelHeaderTemplate = (options) => {
        const { className, checkboxElement, filterElement, closeElement } = options;
        return (
            <div className={className} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {checkboxElement}
                    <label style={{ marginLeft: '-7px', fontSize: '13px' }}>Select All</label>
                </div>
                {filterElement}
                {closeElement}
            </div>
        );
    };
    const handleAcceptFirstName= (event) => {
        const inputValue = event.target.value;
      // Allow empty string or a string containing only letters
        if (inputValue === '' || /^[a-zA-Z ]*$/.test(inputValue)) {
        setFirstName(inputValue);
        }
    };
    const handleAcceptLastName= (event) => {
        const inputValue = event.target.value;
      // Allow empty string or a string containing only letters
        if (inputValue === '' || /^[a-zA-Z ]*$/.test(inputValue)) {
        setLastName(inputValue);
        }
    };
    return (

        <div>
            <div className="hd-breadcums">
                <h3 className="main-heading">Edit Profile</h3>
            </div>

            <div className="edit-container">
                <div className="edit profile-wrapper">
                    <div className="edit-field">
                        <label className="edit-profile-label">Profile Image </label>
                        <div className="edit-field-group">

                            <VisibilityToggle isVisible={showprofileImage} onToggle={() => handleVisibilityToggle("showprofileImage", showprofileImage, setShowprofileImage)}
                            >

                            </VisibilityToggle>
                            <div className="form-groups">
                                <div className="profile-img-upload">
                                    <ImageUploader key="profile" type="profile" proImg={proImg} onUploadComplete={onUploadComplete} />
                                    <div className="d-flex switch_info">
                                        <SwitchToggle isVisible={isPrivateProfile} onToggle={() => handleVisibilityToggle("isPrivateProfile", isPrivateProfile, setIsPrivateProfile)}></SwitchToggle>
                                        <OverlayTrigger placement="left" overlay={<Tooltip id="top-tooltip">This is a top tooltip!</Tooltip>}>
                                            <img src={question} alt="test" className="infoicon" />
                                        </OverlayTrigger>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="edit-field">
                        <label className="edit-profile-label">Banner Image</label>
                        <div className="edit-field-group">

                            <VisibilityToggle isVisible={showCoverImage} onToggle={() => handleVisibilityToggle("showCoverImage", showCoverImage, setShowCoverImage)}
                            >

                            </VisibilityToggle>
                            <div className="form-groups ml-zer">
                                <div className="profile-img-upload banner-upload">
                                    <ImageUploader key="cover" type="cover" proImg={coverImg} onUploadComplete={onUploadComplete} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="edit-field">
                        <label className="edit-profile-label">First name <sup>*</sup></label>
                        <div className="edit-field-group">
                            <div className="form-group">
                                <input type="text" ref={firstNameRef} placeholder="First name" className="form-control" onChange={handleAcceptFirstName} value={firstName} />
                                {firstName === "" && error ? (
                                    <Validation message={'Please enter first name'} />
                                ) : null}
                                 {firstName && /\d/.test(firstName) ? (
                                    <Validation message={'Please enter a valid first name'} />
                                ) : null}
                            </div>
                        </div>
                    </div>

                    <div className="edit-field">
                        <label className="edit-profile-label">Last name <sup>*</sup></label>
                        <div className="edit-field-group">
                            <div className="form-group">
                                <input type="text" ref={lastNameRef} placeholder="Last name" className="form-control" onChange={handleAcceptLastName} value={lastName}></input>
                                {lastName === "" && error ? (
                                    <Validation message={'Please enter last name'} />
                                ) : null}
                                 {lastName && /\d/.test(lastName) ? (
                                <Validation message={'Please enter a valid last name'} />
                                ) : null}
                            </div>
                        </div>
                    </div>

                    <div className="edit-field">
                        <label className="edit-profile-label">Email Id <sup>*</sup></label>
                        <div className="edit-field-group">
                            <div className="form-group position-relative">
                                <input type="text" placeholder="Email" className="form-control" value={email} readOnly></input>
                                <button className="leave" onClick={(e) => { e.preventDefault(); setIsEditEmail(true) }}  >Change</button>
                                {email === "" && error ? (
                                    <Validation message={'Please enter email'} />
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="subheading">

                        <div className="border-customs">
                            <div className="p-q-thumb">
                                <CircularProgress percentage={basicPercentage} />
                            </div>
                        </div>
                        <h4>About Me</h4>
                        <span></span>
                    </div>

                    <div className="edit-field">
                        <label className="edit-profile-label">Gender</label>
                        <div className="edit-field-group">
                            <VisibilityToggle isVisible={showGender} onToggle={() => handleVisibilityToggle("showGender", showGender, setShowGender)}
                            >

                            </VisibilityToggle>
                            <div className="form-group">
                                <Form.Select /* className="form-control"  */ aria-label="Default select example" onChange={(e) => { setGender(e.target.value) }} value={gender}>
                                    <option value="">Select...</option>
                                    <option value="Female">Female</option>
                                    <option value="Male">Male</option>
                                </Form.Select>
                            </div>
                        </div>
                    </div>

                    <div className="edit-field">
                        <label className="edit-profile-label">Date of Birth <sup>*</sup></label>
                        <div className="edit-field-group">
                            <VisibilityToggle isVisible={showDob} onToggle={() => handleVisibilityToggle("showDob", showDob, setShowDob)}
                            >

                            </VisibilityToggle>
                            <div className="form-group" ref={dobRef}>
                                <div className="dob-splitter mt-3">
                                    <div className="splitter-itm">
                                        <div className="form-input">
                                            
                                            <Form.Select /* className="form-control"  */ aria-label="Default select example" placeholder="Month"
                                                value={month}
                                                onChange={(e) => setMonth(e.target.value)}>
                                                {months.map((m) => (
                                                <option key={m.value} value={m.value}>
                                                    {m.label}
                                                </option>
                                                ))}
                                            </Form.Select>
                                        </div>
                                    </div>
                                    <div className="splitter-itm">
                                        <div className="form-input">
                                            <input type="number" className="form-control"
                                            placeholder="Day"
                                            value={day}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === '') setDay('');
                                                else {
                                                const num = Math.min(Math.max(parseInt(val), 1), 31);
                                                setDay(num.toString());
                                                }
                                            }}
                                            min="1"
                                            max="31" />
                                        </div>
                                    </div>
                                    <div className="splitter-itm">
                                        <div className="form-input">
                                            <input  type="number" className="form-control"
                                            placeholder="Year"
                                            value={year}
                                           onChange={(e) => {
                                                // Just update the raw text
                                                setYear(e.target.value);
                                            }}
                                            onBlur={(e) => {
                                                const val = e.target.value;
                                                if (val === '') return;
                                                const num = Math.min(Math.max(parseInt(val), 1910), 2200);
                                                setYear(num.toString());
                                            }}
                                            min="1910"
                                            max={new Date().getFullYear()}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-none">
                                <Datetime
                                    dateFormat="MM/DD/YYYY"
                                    inputProps={{
                                        onFocus: handleFocus,
                                        placeholder: 'e.g. 01/21/2025'
                                    }}
                                    timeFormat={false}
                                    open={isCalendarOpen}
                                    onChange={handleChange}
                                    value={dob}
                                />                              

                            </div>
                            {dob === "" && error ? (
                                    <Validation message={'Please enter date of birth'} />
                                ) : null}
                                 {(error && (!month || !day || !year)) && (
                                    <Validation message="Please enter date of birth" />
                                )}
                                {dobError &&
                                    <Validation message={dobError} />}
                                    {dateError &&
                                    <Validation message={dateError} />}
                            </div>
                        </div>
                    </div>

                    <div className="edit-field">
                        <label className="edit-profile-label">Phone Number</label>
                        <div className="edit-field-group">
                            <div className="form-group">
                                <input type="text" placeholder="Phone number" className="form-control" onChange={(e) => { setPhNo(e.target.value) }} value={phNo}></input>
                            </div>
                        </div>
                    </div>

                    <div className="edit-field">
                        <label className="edit-profile-label">Ethnicity</label>
                        <div className="edit-field-group">
                            <div className="form-group">
                                <Form.Select /* className="form-control"  */ aria-label="Default select example" onChange={(e) => { setEthnicity(e.target.value) }} value={ethnicity}>
                                    <option value="">Select...</option>
                                    <option value="White">White</option>
                                    <option value="Black or African American">Black or African American</option>
                                    <option value="Hispanic or Latino">Hispanic or Latino</option>
                                    <option value="Asian">Asian</option>
                                    <option value="Native American or Alaska Native">Native American or Alaska Native</option>
                                    <option value="Native Haaiian or Pacific Islander">Native Haaiian or Pacific Islander</option>
                                    <option value="Middle Eastern">Middle Eastern</option>
                                    <option value="Other">Other</option>
                                </Form.Select>
                            </div>
                        </div>
                    </div>

                    <div className="edit-field">
                        <label className="edit-profile-label">Are you or have you been in the Military?</label>
                        <div className="edit-field-group">
                            <div className="form-group">
                                <Form.Select /* className="form-control"  */ aria-label="Default select example" onChange={(e) => { setMilitary(e.target.value) }} value={military}>
                                    <option value="">Select...</option>
                                    <option value="Currently in the military">Currently in the military</option>
                                    <option value="Veteran">Veteran</option>
                                    <option value="No">No</option>
                                </Form.Select>
                            </div>
                        </div>
                    </div>

                    <div className="edit-field">
                        <label className="edit-profile-label">Country <sup>*</sup></label>
                        <div className="edit-field-group">
                            <VisibilityToggle isVisible={showCountry} onToggle={() => handleVisibilityToggle("showCountry", showCountry, setShowCountry)}
                            >

                            </VisibilityToggle>
                            <div className="form-group">
                                <Form.Select /* className="form-control" */ aria-label="Default select example" onChange={(e) => { {setCountry(e.target.value); setDobError("")} }} value={country}>
                                    <option value="Select...."></option>
                                    {Array.isArray(countryArr) &&
                                        countryArr.map((item) => (
                                            <option key={item._id} value={item._id}>{item.countryName}</option>
                                        ))}
                                </Form.Select>
                            </div>
                        </div>
                    </div>

                    {country === "681dde46519da80203bdf80f" &&
                        <>
                            <div className="edit-field">
                                <label className="edit-profile-label">Zip Code <sup>*</sup></label>
                                <div className="edit-field-group">
                                    <VisibilityToggle isVisible={showZipcode} onToggle={() => handleVisibilityToggle("showZipcode", showZipcode, setShowZipcode)}
                                    >

                                    </VisibilityToggle>
                                    <div className="form-group">
                                        <input type="text" ref={zipRef} placeholder="zip code" className="form-control" 
                                        onChange={(e) => { const value = e.target.value;
                                                            if (/^\d{0,5}$/.test(value)) { // restricts to 0–5 digits only
                                                                setZip(value);
                                                            } }} value={zip}></input>
                                        {zip && !/^\d{5}$/.test(zip) && (
                                            <Validation message="ZIP code must be exactly 5 digits" />
                                        )}
                                        {zip === "" && error ? (
                                            <Validation message={'Please enter zip code'} />
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            <div className="edit-field">
                                <label className="edit-profile-label">Location</label>
                                <div className="edit-field-group">
                                    <VisibilityToggle isVisible={showLocation} onToggle={() => handleVisibilityToggle("showLocation", showLocation, setShowLocation)}
                                    >

                                    </VisibilityToggle>
                                    <div className="form-group">
                                        <input type="text" placeholder="Location" className="form-control" value={location} ></input>
                                    </div>
                                </div>
                            </div></>}

                    <div className="edit-field">
                        <label className="edit-profile-label">Bio</label>
                        <div className="edit-field-group">
                            <VisibilityToggle isVisible={showBio} onToggle={() => handleVisibilityToggle("showBio", showBio, setShowBio)}
                            >

                            </VisibilityToggle>
                            <div className="form-group">
                                
                                <textarea className="form-control" onChange={(e) => { setBio(e.target.value) }} value={bio}></textarea>
                            </div>
                        </div>
                    </div>

                    {individualBasicQuestions?.map((question, qIndex) => {
                        let formattedOption = {}
                        if (question.questionControlType === "multiselect") {
                            formattedOption = question.answerOptions.map((item, index) => ({
                                name: item,
                                code: item,
                            }));
                        }

                        return (
                            <div className="edit-field bg-light p-2 rounded" key={question._id}>
                                <label className="edit-profile-label question">{question.question}</label>
                                <div className="edit-field-group">
                                    <div className="form-group position-relative">
                                        {question.questionControlType === "multichoice" && <Form.Select aria-label="Default select example"
                                            value={question?.answer?.[0]?.answer?.[0] || {}}
                                            onChange={(e) => handleIndividualQuestionChange(question._id, e.target.value)}


                                        >
                                            <option value="">Select...</option>
                                            {question.answerOptions.map((opt, index) => (
                                                <option value={opt}>{opt}</option>
                                            ))}
                                        </Form.Select>}
                                        {question.questionControlType === "textfield" &&
                                            <div className="radio-input">
                                                <Form.Group className="" >
                                                    <Form.Control as="textarea" rows={1}
                                                        value={question?.answer?.[0]?.answer?.[0] || ""}
                                                        onChange={(e) => {
                                                            const newValue = e.target.value;
                                                            const dataType = question.answerDataType;

                                                            // Simple per-type validation
                                                            let isValid = true;
                                                            if (dataType === "number") isValid = /^[0-9]*$/.test(newValue);
                                                            else if (dataType === "zipcode") isValid = /^[0-9]{0,5}$/.test(newValue);
                                                            else if (dataType === "string") isValid = /^[a-zA-Z\s.,'-]*$/.test(newValue);
                                                            if (!isValid) return;

                                                            handleIndividualQuestionChange(question._id, newValue);
                                                        }}
                                                    
                                                    />
                                                </Form.Group>
                                            </div>}
                                        
                                            {question.questionControlType === "date" && (() => {
                                                                                        const existingDate = question?.answer?.[0]?.answer?.[0]
                                                                                            ? moment(question.answer[0].answer[0]).format("MM/DD/YYYY")
                                                                                            : "";
                                            
                                                                                        // initialize refs for this specific question ID
                                                                                        if (!monthRefs.current[question._id]) monthRefs.current[question._id] = "";
                                                                                        if (!dayRefs.current[question._id]) dayRefs.current[question._id] = "";
                                                                                        if (!yearRefs.current[question._id]) yearRefs.current[question._id] = "";
                                            
                                                                                        if (existingDate && !monthRefs.current[question._id]) {
                                                                                            const [m, d, y] = existingDate.split("/");
                                                                                            monthRefs.current[question._id] = m;
                                                                                            dayRefs.current[question._id] = d;
                                                                                            yearRefs.current[question._id] = y;
                                                                                        }
                                            
                                                                                        const formatCustomDate = (m, d, y) => {
                                                                                            if (!m || !d || !y) return "";
                                                                                            return `${m.padStart(2, "0")}/${d.toString().padStart(2, "0")}/${y}`;
                                                                                        };
                                            
                                                                                        // const updateDate = (newMonth, newDay, newYear) => {
                                                                                        //     const formatted = formatCustomDate(newMonth, newDay, newYear);
                                                                                        //     handleIndividualQuestionChange(question._id, formatted);
                                                                                        //     forceRender((p) => p + 1);
                                                                                        // };
                                                                                        const updateDate = (newMonth, newDay, newYear) => {
                                                                                        const formatted = formatCustomDate(newMonth, newDay, newYear);
                                            
                                                                                        // --- ✅ Validate only when all fields are filled ---
                                                                                        if (newMonth && newDay && newYear) {
                                                                                            const parsedDate = new Date(formatted);
                                            
                                                                                            const isValid =
                                                                                            parsedDate instanceof Date &&
                                                                                            !isNaN(parsedDate) &&
                                                                                            parsedDate.getMonth() + 1 === parseInt(newMonth) &&
                                                                                            parsedDate.getDate() === parseInt(newDay) &&
                                                                                            parsedDate.getFullYear() === parseInt(newYear);
                                            
                                                                                            if (isValid) {
                                                                                            handleIndividualQuestionChange(question._id, formatted);
                                                                                            } else {
                                                                                            // invalid combination like 02/31/1990
                                                                                            handleIndividualQuestionChange(question._id, "INVALID_DATE");
                                                                                            }
                                                                                        } else {
                                                                                            // partial date (user still typing)
                                                                                            handleIndividualQuestionChange(question._id, formatted);
                                                                                        }
                                            
                                                                                        forceRender((p) => p + 1);
                                                                                        };
                                            
                                            
                                                                                        return (
                                                                                            <div className="dob-splitter">
                                                                                            {/* Month Dropdown */}
                                                                                            <div className="splitter-itm">
                                                                                                <div className="form-input">
                                                                                                <Form.Select
                                                                                                    aria-label="Default select example"
                                                                                                    value={monthRefs.current[question._id]}
                                                                                                    onChange={(e) => {
                                                                                                    monthRefs.current[question._id] = e.target.value;
                                                                                                    updateDate(
                                                                                                        monthRefs.current[question._id],
                                                                                                        dayRefs.current[question._id],
                                                                                                        yearRefs.current[question._id]
                                                                                                    );
                                                                                                    }}
                                                                                                >
                                                                                                    {months.map((m) => (
                                                                                                    <option key={m.value} value={m.value}>
                                                                                                        {m.label}
                                                                                                    </option>
                                                                                                    ))}
                                                                                                </Form.Select>
                                                                                                </div>
                                                                                            </div>
                                            
                                                                                            {/* Day Input */}
                                                                                            <div className="splitter-itm">
                                                                                                <div className="form-input">
                                                                                                <input
                                                                                                    // type="text"
                                                                                                    // inputMode="numeric"
                                                                                                    type="number"
                                                                                                    placeholder="Day"
                                                                                                    value={dayRefs.current[question._id]}
                                                                                                    onChange={(e) => {
                                                                                                    const val = e.target.value;
                                                                                                    dayRefs.current[question._id] = val;
                                                                                                    updateDate(
                                                                                                        monthRefs.current[question._id],
                                                                                                        val,
                                                                                                        yearRefs.current[question._id]
                                                                                                    );
                                                                                                    }}
                                                                                                    onBlur={(e) => {
                                                                                                    const val = parseInt(e.target.value);
                                                                                                    if (!val) return;
                                                                                                    const clamped = Math.min(Math.max(val, 1), 31);
                                                                                                    dayRefs.current[question._id] = clamped.toString();
                                                                                                    updateDate(
                                                                                                        monthRefs.current[question._id],
                                                                                                        dayRefs.current[question._id],
                                                                                                        yearRefs.current[question._id]
                                                                                                    );
                                                                                                    }}
                                                                                                    className="form-control"
                                                                                                    maxLength="2"
                                                                                                    min="1"
                                                                                                    max="31"
                                                                                                    onKeyDown={(e) => {
                                              if (e.key === "0" && e.target.value === "") {
                                                e.preventDefault(); // prevent typing 0 as first digit
                                              }
                                            }}
                                                                                                />
                                                                                                </div>
                                                                                            </div>
                                            
                                                                                            {/* Year Input */}
                                                                                            <div className="splitter-itm">
                                                                                                <div className="form-input">
                                                                                                <input
                                                                                                    // type="text"
                                                                                                    // inputMode="numeric"
                                                                                                    type="number"
                                                                                                    placeholder="Year"
                                                                                                    value={yearRefs.current[question._id]}
                                                                                                    onChange={(e) => {
                                                                                                    const val = e.target.value;
                                                                                                    yearRefs.current[question._id] = val;
                                                                                                    updateDate(
                                                                                                        monthRefs.current[question._id],
                                                                                                        dayRefs.current[question._id],
                                                                                                        val
                                                                                                    );
                                                                                                    }}
                                                                                                    onBlur={(e) => {
                                                                                                    const val = parseInt(e.target.value);
                                                                                                    if (!val) return;
                                                                                                    const clamped = Math.min(Math.max(val, 1900), 2200);
                                                                                                    yearRefs.current[question._id] = clamped.toString();
                                                                                                    updateDate(
                                                                                                        monthRefs.current[question._id],
                                                                                                        dayRefs.current[question._id],
                                                                                                        yearRefs.current[question._id]
                                                                                                    );
                                                                                                    }}
                                                                                                    className="form-control"
                                                                                                    maxLength="4"
                                                                                                     min="1900"
                                                                                                    max={new Date().getFullYear()}
                                                                                                />
                                                                                                </div>
                                                                                            </div>
                                                                                            </div>
                                                                                        );
                                                                                        })()}
                                            {question?.answer?.[0]?.answer?.[0] === "INVALID_DATE" && (
                                              <Validation message={'Please enter a valid date '} />
                                            )}
                                        {question.questionControlType === "multiselect" &&
                                            <div className="radio-input">
                                                <MultiSelect
                                                    optionLabel="name"
                                                    options={formattedOption} // e.g., [{ name: "Hormone Therapy", code: "Hormone Therapy" }]
                                                    value={
                                                        Array.isArray(question?.answer?.[0]?.answer)
                                                            ? formattedOption.filter(opt => question.answer[0].answer.includes(opt.code))
                                                            : []
                                                    }
                                                    placeholder="Choose..."
                                                    maxSelectedLabels={1}
                                                    className=""
                                                    showSelectAll
                                                    panelHeaderTemplate={panelHeaderTemplate}

                                                    onChange={(e) => {
                                                        const selectedValues = e.value.map(item => item.code);
                                                        handleIndividualQuestionChange(question._id, selectedValues);
                                                    }}

                                                />


                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    })}


                    <div className="subheading">
                        <h4>Community</h4>
                        <span></span>
                    </div>

                    {CommunityArr.map((community, cIndex) => {
                        const isCaregiver = community?.membertype?.[0]?.memberTypeDisplayName === "caregiver";

                        
                        const mergedQuestions = [
                            ...(community?.communityquestions || []).map(q => ({ ...q, source: 'communityquestions' })),
                            ...(isCaregiver ? (community?.caregiverquestions || []).map(q => ({ ...q, source: 'caregiverquestions' })) : [])
                        ];

                        return (
                            <>
                                <div className="edit-field">

                                    <label className="edit-profile-label main-label_e-dh">{community?.community[0]?.communityName}</label>
                                    <div className="edit-field-group">
                                        <div className="form-group position-relative">
                                            <input type="text" placeholder="Member" className="form-control" value={community?.membertype[0]?.memberTypeDisplayName} readOnly></input>
                                            <button className="leave" onClick={(e) => { e.preventDefault(); setSelectedCommunity(community); setIsLeaveCommunity(true) }}  >Leave</button>
                                        </div>
                                    </div>
                                </div>

                                <div className="profile-Q-edit mt-4">
                                    <div
                                        onClick={() => toggleCommunityCollapse(community.community[0]?._id)}
                                        aria-controls="collapse-content"
                                        aria-expanded={!!openStates[community.community[0]?._id]}
                                        className="d-flex align-items-center justify-content-start g-3"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="border-customs">
                                            <div className="p-q-thumb" >
                                                <CircularProgress percentage={community?.profileQuestionsCompleted ? community?.profileQuestionsCompleted : "0"} />
                                            </div>
                                        </div>


                                        <span className="dh-qstn-profile-edit" >{`${community?.community[0]?.communityName} Community Profile Questions`}</span>
                                        <span className="line" ></span>
                                        
                                        <FontAwesomeIcon icon={openStates[community.community[0]?._id] ? faMinus : faPlus} />

                                    </div>

                                    <Collapse in={!!openStates[community.community[0]?._id]}>

                                        <div id="collapse-content" className="bg-white p-questions-view">
                                            {mergedQuestions?.map((question, qIndex) => {
                                                let formattedOption = {}
                                                if (question.questionControlType === "multiselect") {
                                                    formattedOption = question.answerOptions.map((item, index) => ({
                                                        name: item,
                                                        code: item,
                                                    }));
                                                }

                                                return (
                                                    <div className="edit-field" key={question._id}>
                                                        <label className="edit-profile-label">{question.question}</label>
                                                        <div className="edit-field-group">
                                                            <div className="form-group position-relative">
                                                                {question.questionControlType === "multichoice" && <Form.Select aria-label="Default select example" value={question?.answer?.[0]?.answer?.[0] || {}}

                                                                    onChange={(e) => {
                                                                        const updatedCommunities = [...CommunityArr];
                                                                        const selectedValue = e.target.value;
                                                                        const sourceArray = question.source; // "communityquestions" or "caregiverquestions"
                                                                        const questionId = question._id;

                                                                        const questionList = updatedCommunities[cIndex][sourceArray];

                                                                        const foundIndex = questionList.findIndex(q => q._id === questionId);

                                                                        if (foundIndex !== -1) {
                                                                            if (questionList[foundIndex].answer?.[0]) {
                                                                                questionList[foundIndex].answer[0].answer = [selectedValue];
                                                                            } else {
                                                                                questionList[foundIndex].answer = [{ answer: [selectedValue] }];
                                                                            }
                                                                        }

                                                                        setCommunityArr(updatedCommunities);
                                                                    }}

                                                                >
                                                                    <option value="">Select...</option>
                                                                    {question.answerOptions.map((opt, index) => (
                                                                        <option value={opt}>{opt}</option>
                                                                    ))}
                                                                </Form.Select>}
                                                                {question.questionControlType === "textfield" &&
                                                                    <div className="radio-input">
                                                                        <Form.Group className="" >
                                                                            <Form.Control as="textarea" rows={1}
                                                                                value={question?.answer?.[0]?.answer?.[0] || ""}

                                                                                onChange={(e) => {

                                                                                    const text = e.target.value;
                                                                                    const dataType = question.answerdatatype; // string | number | zipcode

                                                                                    let isValid = true;

                                                                                    // ✅ Validation logic based on answerDatatype
                                                                                    if (dataType === "number") {
                                                                                        // Allow only digits
                                                                                        isValid = /^[0-9]*$/.test(text);
                                                                                    } else if (dataType === "string") {
                                                                                        // Allow letters, spaces, basic punctuation
                                                                                        isValid = /^[a-zA-Z\s.,'-]*$/.test(text);
                                                                                    } else if (dataType === "zipcode") {
                                                                                        // Allow up to 5 digits only
                                                                                        isValid = /^[0-9]{0,5}$/.test(text);
                                                                                    }

                                                                                    if (!isValid) return; // stop update if invalid input
                                                                                    const updatedCommunities = [...CommunityArr];
                                                                                    // const text = e.target.value;
                                                                                    const sourceArray = question.source; // "communityquestions" or "caregiverquestions"
                                                                                    const questionId = question._id;

                                                                                    const questionList = updatedCommunities[cIndex][sourceArray];

                                                                                    const foundIndex = questionList.findIndex(q => q._id === questionId);

                                                                                    if (foundIndex !== -1) {
                                                                                        if (questionList[foundIndex].answer?.[0]) {
                                                                                            questionList[foundIndex].answer[0].answer = [text];
                                                                                        } else {
                                                                                            questionList[foundIndex].answer = [{ answer: [text] }];
                                                                                        }
                                                                                    }

                                                                                    setCommunityArr(updatedCommunities);
                                                                                }}
                                                                            />
                                                                        </Form.Group>
                                                                    </div>}
                                                                
                                                                    {question.questionControlType === "date" && (
  <CustomDatePicker
    question={question}
    cIndex={cIndex}
    CommunityArr={CommunityArr}
    setCommunityArr={setCommunityArr}
    onValidationChange={(invalid) =>
    setDateValidMap((prev) => ({ ...prev, [question._id]: invalid }))
  }
    
  />
)}
{dateValidMap[question._id] && <Validation message="Please enter a valid date" />}



                                                                {question.questionControlType === "multiselect" &&
                                                                    <div className="radio-input">
                                                                        <MultiSelect
                                                                            optionLabel="name"
                                                                            options={formattedOption} // e.g., [{ name: "Hormone Therapy", code: "Hormone Therapy" }]
                                                                            value={
                                                                                Array.isArray(question?.answer?.[0]?.answer)
                                                                                    ? formattedOption.filter(opt => question.answer[0].answer.includes(opt.code))
                                                                                    : []
                                                                            }
                                                                            placeholder="Choose..."
                                                                            maxSelectedLabels={1}
                                                                            className=""
                                                                            showSelectAll
                                                                            panelHeaderTemplate={panelHeaderTemplate}

                                                                            onChange={(e) => {
                                                                                const updatedCommunities = [...CommunityArr];
                                                                                const selectedValue = e.value;
                                                                                const selectedCodes = selectedValue.map(item => item.code);
                                                                                const sourceArray = question.source; // "communityquestions" or "caregiverquestions"
                                                                                const questionId = question._id;

                                                                                const questionList = updatedCommunities[cIndex][sourceArray];

                                                                                const foundIndex = questionList.findIndex(q => q._id === questionId);

                                                                                if (foundIndex !== -1) {
                                                                                    if (questionList[foundIndex].answer?.[0]) {
                                                                                        questionList[foundIndex].answer[0].answer = selectedCodes;
                                                                                    } else {
                                                                                        questionList[foundIndex].answer = [{ answer: selectedCodes }];
                                                                                    }
                                                                                }

                                                                                setCommunityArr(updatedCommunities);
                                                                            }}

                                                                        />


                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}



                                        </div>

                                    </Collapse>
                                </div>
                            </>
                        )
                    })}

                    <div className="main-action-buttons">
                        <button className="act-buttons bg-light text-dark" onClick={() => navigate('/profile')}>Cancel</button>
                        <button className="act-buttons" onClick={() => updateProfileDetails()}>Update</button>
                    </div>
                    <div className="delete-acc pb-5">
                        <button onClick={(e) => { e.preventDefault(); setIsDeleteAccount(true) }}>Delete Account ?

                        </button>
                    </div>



                </div>
            </div>
            {isEditEmail && <EditEmail isEditEmail={isEditEmail} handleClose={handleEditEmailClose} onSuccess={handleEmailSuccess} />}
            {CommunityArr.length > 1 ?
                isLeaveCommunity ? <LeaveCommunity isLeaveCommunity={isLeaveCommunity} handleClose={handleLeaveClose} community={selectedCommunity} getCommunity={removeCommunities} root="edit" /> : null
                : <DeleteAccount isLeaveCommunity={isLeaveCommunity} handleClose={handleLeaveClose} />}

            {isDeleteAccount && <DeleteAccount isLeaveCommunity={isDeleteAccount} handleClose={handleDeleteAccountClose} />}
            {isSucess && (<ResponsePopup
                isSucess={isSucess}
                CancelPopup={() => {
                    SetSucess(false);
                }}
                message={ResponseMessage}
            />)}
        </div>
    );

};
export default EditProfile;